import React from "react";

const ActionIcon = ({ isReminder, type }) => {
  return (
    <span
      className={`d-flex align-items-center justify-content-center text-white rounded-circle size-50px f20 align-middle ${
        isReminder ? "bg-bronze-500" : "bg-blue-500"
      }`}
    >
      {type?.includes("Email") ? (
        <i class="bi bi-envelope-fill"></i>
      ) : type?.includes("Call") ? (
        <i class="bi bi-telephone-inbound-fill"></i>
      ) : type?.includes("Video") ? (
        <i class="bi bi-camera-video-fill"></i>
      ) : (
        <i class="bi bi-shop"></i>
      )}
    </span>
  );
};

export default ActionIcon;
